import { Role } from 'types/roles';

export type RoleKey = 'ubo' | 'director' | 'shareholder' | 'signatory' | 'user';
export type PermissionDetails = { title: string; description: string };

export const RELATIONS_ROLES: { key: RoleKey; title: string }[] = [
	{ key: 'ubo', title: 'ubo' },
	{ key: 'director', title: 'director' },
	{ key: 'shareholder', title: 'shareholder' },
	{ key: 'signatory', title: 'signatory' },
	{ key: 'user', title: 'user' },
];

export const PERMISSION_INFO: Record<Role, PermissionDetails> = {
	[Role.VIEW]: { title: 'viewer', description: 'viewerDescription' },
	[Role.CREATE]: { title: 'creator', description: 'creatorDescription' },
	[Role.CREATE_SIGN]: { title: 'createSigner', description: 'createSignerDescription' },
	[Role.SIGN]: { title: 'signer', description: 'signerDescription' },
	[Role.MANAGE]: { title: 'manager', description: 'managerDescription' },
};

export const EMPTY_VALUE = '-';
